import * as React from "react";
import Logo from "./HORIZONTAL 2.svg"
function SvgComponent(props) {
  return (
    <div>
      <img src={Logo} alt="Logo" style={{ width: '150px', height: 'auto', marginTop: '1rem' }} />
    </div>
  );
}



export default SvgComponent;
